import { Counter } from '@/components/motion/Counter'
import { Reveal } from '@/components/motion/Reveal'
import { useTranslations } from '@/app/site-context'

export function Stats() {
  const { stats } = useTranslations()

  return (
    <section className="stats" aria-labelledby="stats-title">
      <h2 className="visually-hidden" id="stats-title">
        {stats.title}
      </h2>
      <dl className="stats__grid">
        {stats.items.map((item, index) => (
          <Reveal
            as="div"
            variant="slam"
            delay={index * 90}
            className="stats__cell"
            key={item.label}
          >
            <dt className="stats__value">
              <Counter value={item.value} />
            </dt>
            <dd className="stats__label">{item.label}</dd>
          </Reveal>
        ))}
      </dl>
    </section>
  )
}
